/* ioc-subs.js · Run 4 subscription layer.
   1. Subscribe page: Regular / Gluten Friendly toggle shows the matching pane in every pack card; the cadence radios
      swap which plan price is visible. Every price was rendered by Liquid from Shopify objects; this only toggles.
   2. PDP selling-plan block: Horizon's variant picker fetches the section HTML on every variant change and fires
      shopify:product:select with a promise that resolves to that HTML. We lift the re-rendered block out of it,
      swap the option list, and keep the shopper's chosen cadence (by plan name) or one-time choice.
   Hooks are all data-ioc-*; nothing here touches Horizon's own components. */
(function () {
  function ready(fn) { if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn); else fn(); }

  /* ---------- subscribe page: type toggle ---------- */
  function initTypeToggle(root) {
    var toggle = root.querySelector("[data-ioc-type-toggle]");
    if (!toggle || toggle.dataset.bound) return;
    toggle.dataset.bound = "1";
    toggle.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-ioc-type-btn]");
      if (!btn) return;
      var type = btn.getAttribute("data-ioc-type-btn");
      toggle.querySelectorAll("[data-ioc-type-btn]").forEach(function (b) {
        var on = b === btn;
        b.classList.toggle("is-on", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
      root.querySelectorAll("[data-ioc-pane]").forEach(function (pane) {
        pane.hidden = pane.getAttribute("data-ioc-type") !== type;
      });
    });
  }

  /* ---------- subscribe page: cadence radios pick the visible plan price ---------- */
  function syncPane(pane) {
    var checked = pane.querySelector("input[name='selling_plan']:checked");
    if (!checked) return;
    var id = checked.value;
    pane.querySelectorAll("[data-ioc-plan-price]").forEach(function (el) {
      el.hidden = el.getAttribute("data-ioc-plan-price") !== id;
    });
  }
  function initPanes(root) {
    root.querySelectorAll("[data-ioc-pane]").forEach(function (pane) {
      if (pane.dataset.bound) return;
      pane.dataset.bound = "1";
      pane.addEventListener("change", function (e) {
        if (e.target && e.target.name === "selling_plan") syncPane(pane);
      });
      syncPane(pane);
    });
  }

  /* ---------- PDP block: follow the variant ---------- */
  function onProductSelect(event) {
    if (!event || !event.promise || typeof event.promise.then !== "function") return;
    var target = event.target;
    var section = target && target.closest ? target.closest(".shopify-section, dialog") : null;
    var current = section ? section.querySelector("[data-ioc-selling-plan]") : null;
    if (!current) return;
    event.promise.then(function (result) {
      var detail = result && result.detail;
      var html = detail && detail.html;
      if (!html || !html.querySelector) return;
      var next = html.querySelector("[data-ioc-selling-plan][data-block-id='" + current.getAttribute("data-block-id") + "']");
      if (!next) return;
      var oldChecked = current.querySelector("input[name='selling_plan']:checked");
      var wantOneTime = !!oldChecked && oldChecked.value === "";
      var wantName = oldChecked ? oldChecked.getAttribute("data-ioc-plan-name") : null;
      var wantId = oldChecked ? oldChecked.value : null;

      var oldOpts = current.querySelector("[data-ioc-plan-options]");
      var newOpts = next.querySelector("[data-ioc-plan-options]");
      if (oldOpts && newOpts) oldOpts.replaceWith(newOpts);

      var oldShip = current.querySelector("[data-ioc-ship-free]");
      var newShip = next.querySelector("[data-ioc-ship-free]");
      if (oldShip && newShip) oldShip.replaceWith(newShip);
      else if (oldShip && !newShip) oldShip.remove();
      else if (!oldShip && newShip) {
        var note = current.querySelector(".ioc-selling-plan__note");
        if (note) note.before(newShip); else current.appendChild(newShip);
      }

      var inputs = Array.prototype.slice.call(current.querySelectorAll("input[name='selling_plan']"));
      if (!inputs.length) return;
      var pick = null;
      if (wantOneTime) pick = inputs.filter(function (i) { return i.value === ""; })[0] || null;
      if (!pick && wantId) pick = inputs.filter(function (i) { return i.value === wantId; })[0] || null;
      if (!pick && wantName) pick = inputs.filter(function (i) { return i.getAttribute("data-ioc-plan-name") === wantName; })[0] || null;
      if (!pick) pick = inputs.filter(function (i) { return i.checked; })[0] || inputs[0];
      inputs.forEach(function (i) { i.checked = i === pick; });
    }).catch(function () {});
  }

  /* ---------- B4 (SA port, row 1): count-up, reveal, video toggle ----------
     Ported from sa-page-subscribe.liquid, renamed to data-ioc-* and .ioc-rv, and every motion gated on the OS
     reduced-motion setting or the site's own pause switch (html.ioc-motion-paused): with motion off the number lands
     at once and the reveal is instant. */
  function motionOff() {
    if (document.documentElement.classList.contains("ioc-motion-paused")) return true;
    return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }
  function countUp(el) {
    if (el.dataset.iocDone) return;
    el.dataset.iocDone = "1";
    var raw = String(el.getAttribute("data-ioc-count") || "").trim();
    var target = parseFloat(raw);
    if (isNaN(target)) return;
    var dec = raw.indexOf(".") > -1 ? raw.split(".")[1].length : 0;
    var suffix = raw.replace(/^[\d.]+/, "");
    var final = target.toFixed(dec) + suffix;
    if (motionOff() || !window.requestAnimationFrame) { el.textContent = final; return; }
    var t0 = performance.now();
    (function tick(t) {
      var k = Math.min(1, (t - t0) / 900), e = 1 - Math.pow(1 - k, 3);
      el.textContent = (target * e).toFixed(dec) + suffix;
      if (k < 1) requestAnimationFrame(tick); else el.textContent = final;
    })(t0);
  }
  function reveal(el) {
    el.classList.add("in");
    el.querySelectorAll("[data-ioc-count]").forEach(countUp);
    if (el.hasAttribute("data-ioc-count")) countUp(el);
  }
  function initReveal(root) {
    var els = Array.prototype.slice.call(root.querySelectorAll(".ioc-rv")).filter(function (e) { return !e.dataset.iocRv; });
    if (!els.length) return;
    els.forEach(function (e) { e.dataset.iocRv = "1"; });
    if (!("IntersectionObserver" in window) || motionOff()) { els.forEach(reveal); return; }
    document.documentElement.classList.add("ioc-rv-arm");
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { reveal(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }
  function initVideo(root) {
    root.querySelectorAll("[data-ioc-vid]").forEach(function (vc) {
      if (vc.dataset.bound) return;
      var v = vc.querySelector("video");
      if (!v) return;
      vc.dataset.bound = "1";
      vc.setAttribute("role", "button");
      vc.setAttribute("tabindex", "0");
      var cap = vc.querySelector(".cap");
      var playLabel = "Play video" + (cap ? ": " + cap.textContent.trim() : "");
      vc.setAttribute("aria-label", playLabel);
      function toggle() {
        if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); vc.classList.add("playing"); vc.setAttribute("aria-label", "Pause video"); }
        else { v.pause(); vc.classList.remove("playing"); vc.setAttribute("aria-label", playLabel); }
      }
      vc.addEventListener("click", toggle);
      vc.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); toggle(); } });
      v.addEventListener("ended", function () { vc.classList.remove("playing"); vc.setAttribute("aria-label", playLabel); });
    });
  }


  /* ---------- House Account: confirm before a recurring charge (H5, CRO gate 2026-09-17) ----------
     START PRO was a bare form submit: one tap put a $79-a-month subscription in the cart with no navigation, no cart
     drawer and no acknowledgement of any kind, so the visitor could not tell anything had happened. That is a
     chargeback generator even though the selling plan underneath is configured correctly.

     The interception is a CAPTURE-phase listener on the form itself, which runs before Horizon's own
     product-form-component submit handler on the ancestor, so nothing reaches the cart until the shopper confirms.
     On confirm we re-submit through the real form, so the native selling-plan path still owns the add, and then we
     open the cart drawer so the result is visible. Nothing here fakes urgency and nothing pre-selects a tier. */
  function initProConfirm(scope) {
    (scope || document).querySelectorAll("[data-ioc-pro-cta]").forEach(function (cta) {
      if (cta.dataset.iocConfirmBound) return;
      var panel = cta.querySelector("[data-ioc-pro-confirm]");
      var form = cta.querySelector("form");
      var addBtn = cta.querySelector("button[name=add]");
      if (!panel || !form || !addBtn) return;
      cta.dataset.iocConfirmBound = "1";
      var yes = panel.querySelector("[data-ioc-pro-yes]");
      var ask = panel.querySelector("[data-ioc-pro-ask]");
      var done = panel.querySelector("[data-ioc-pro-done]");
      var no = panel.querySelector("[data-ioc-pro-no]");
      var confirmed = false;

      var countBefore = null;
      function open() {
        panel.hidden = false;
        addBtn.setAttribute("aria-expanded", "true");
        // Read the cart while the shopper is reading the confirmation, so the "did it work" check afterwards is
        // a real before/after on item_count rather than a guess at a timeout.
        fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (j) { countBefore = j.item_count; })
          .catch(function () { countBefore = null; });
        if (yes) yes.focus();
      }
      function close(refocus) {
        panel.hidden = true;
        addBtn.setAttribute("aria-expanded", "false");
        if (refocus) addBtn.focus();
      }
      addBtn.setAttribute("aria-expanded", "false");
      if (panel.id || addBtn.getAttribute("aria-controls")) { /* id already wired in markup */ }

      /* Horizon adds to cart from the button's own click handler, not only from a form submit, so a submit-phase
         guard alone let the charge through. The gate is therefore a CAPTURE-phase click listener on the ANCESTOR:
         capture on an ancestor always runs before any listener bound on the button itself, whichever path Horizon
         takes. The submit guard stays as well, for a keyboard Enter that skips the click. */
      function gate(e) {
        if (confirmed) return;                          // the confirmed pass: let Horizon have it
        e.preventDefault();
        e.stopImmediatePropagation();
        open();
      }
      cta.addEventListener("click", function (e) {
        var hit = e.target.closest ? e.target.closest("button[name=add]") : null;
        if (!hit || !cta.contains(hit)) return;
        gate(e);
      }, true);
      form.addEventListener("submit", gate, true);

      /* Horizon's drawer auto-open does not fire for the replayed click, and this theme dispatches no cart event
         of its own (nothing in assets/ dispatches "cart:update"), so the result is confirmed by polling the cart
         and then opening the drawer the header already owns. Without this the visitor gets no acknowledgement at
         all that a recurring charge just entered the cart, which is the whole defect being fixed. */
      function showDone() {
        if (!done) return;
        done.textContent = done.getAttribute("data-done") || "";
        var link = document.createElement("a");
        link.href = "/cart";
        link.textContent = "Review your cart";
        done.appendChild(document.createTextNode(" "));
        done.appendChild(link);
        if (ask) ask.hidden = true;
        done.hidden = false;
        panel.hidden = false;
      }
      function revealCart(tries) {
        fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            if (countBefore === null || j.item_count > countBefore) { showDone(); return; }
            if (tries > 0) setTimeout(function () { revealCart(tries - 1); }, 400);
          })
          .catch(function () {});
      }
      if (yes) yes.addEventListener("click", function () {
        confirmed = true;
        close(false);
        // Replay the real button so the native selling-plan add still owns the request, then re-arm the gate.
        addBtn.click();
        setTimeout(function () { confirmed = false; }, 0);
        setTimeout(function () { revealCart(14); }, 500);
      });
      if (no) no.addEventListener("click", function () { close(true); });
      panel.addEventListener("keydown", function (e) { if (e.key === "Escape") { e.stopPropagation(); close(true); } });
    });
  }

  /* ---------- B-Pages: the PLAN-CARD rail on /pages/subscribe (CRO-SPEC 4.5.2 + 5.10) ----------
     1. The type toggle sets &type=<the chosen type> on every plan link (and the action bar's card href), so the builder
        opens on the line the shopper chose. Regular carries &type=regular too (D1-B), so a builder session restored as
        Gluten Friendly never reopens the wrong line from a Regular card.
     2. Phones: the start card (the 12) is scrolled into view on load. Scrolled, never selected.
     The action bar itself (ioc-ui.js) picks the card actually in view inside the rail and keeps the last one when no
     card is on screen, so this file no longer moves data-ioc-abar-card around (D1-B). */
  function initPlanRail(root) {
    if (!root.hasAttribute("data-ioc-plans-rail") || root.dataset.iocPr) return;
    var track = root.querySelector(".pr-rail .ioc-rail__track");
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-ioc-plan-card]"));
    if (!track || !cards.length) return;
    root.dataset.iocPr = "1";
    var firstType = null;
    var toggle = root.querySelector("[data-ioc-type-toggle]");
    if (toggle) {
      var b0 = toggle.querySelector("[data-ioc-type-btn]");
      firstType = b0 ? b0.getAttribute("data-ioc-type-btn") : null;
      toggle.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-ioc-type-btn]");
        if (!btn) return;
        var t = btn.getAttribute("data-ioc-type-btn");
        var extra = t ? "&type=" + encodeURIComponent(t) : "";
        cards.forEach(function (card) {
          var a = card.querySelector("[data-ioc-plan-href]");
          if (!a) return;
          var href = a.getAttribute("data-ioc-plan-href") + extra;
          a.setAttribute("href", href);
          card.setAttribute("data-ioc-abar-href", href);
        });
        try { document.dispatchEvent(new Event("ioc:abar-refresh")); } catch (err) {}
      });
    }
    var start = root.querySelector("[data-ioc-plan-start]");
    if (start && window.innerWidth < 900 && track.scrollWidth > track.clientWidth + 2) {
      var pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      var prev = track.style.scrollBehavior;
      track.style.scrollBehavior = "auto";
      track.scrollLeft = Math.max(0, track.scrollLeft + start.getBoundingClientRect().left - track.getBoundingClientRect().left - pad);
      track.style.scrollBehavior = prev;
    }
  }

  ready(function () {
    var plans = document.querySelectorAll("[data-ioc-plans]");
    plans.forEach(function (root) { initTypeToggle(root); initPanes(root); initPlanRail(root); });
    initReveal(document); initVideo(document);
    initProConfirm(document);
    // The event is dispatched on the variant picker; capture on document catches it whether or not it bubbles.
    document.addEventListener("shopify:product:select", onProductSelect, true);
    // Theme editor re-renders sections; rebind.
    document.addEventListener("shopify:section:load", function () {
      document.querySelectorAll("[data-ioc-plans]").forEach(function (root) { initTypeToggle(root); initPanes(root); });
      initReveal(document); initVideo(document); initProConfirm(document);
    });
  });
})();
